import HighchartsReact from "highcharts-react-official";

import { usePatternFill } from "./usePatternFill";
import Highcharts from "../../lib/charts/customHighCharts";

const Chart = props => {
  const { allowDisplayingPatternFill, chartOptions } = props;

  const { chartOptions: displayedChartOptions, patternFillEnabled } = usePatternFill(
    chartOptions,
    allowDisplayingPatternFill
  );

  // Force a full chart rebuild when pattern fill changes.
  // This prevents the black flash caused by Highcharts animating the fill transition
  // and ensures pattern-specific data label styles are fully cleared.
  const key = patternFillEnabled ? "pattern-fill" : "plain";

  return (
    <HighchartsReact key={key} highcharts={Highcharts} options={displayedChartOptions} />
  );
};

export default Chart;
